module.exports = __webpack_public_path__ + "img/rovignette-status.958806ef.svg";